import React, { useState } from "react";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { useNavigate } from "react-router-dom";

// import JS files

// import others files

const Hashtag = ({ tags }) => {
  const navigate = useNavigate();
  return (
    <>
      <div className="mt-8 bg-mygrays-100 rounded-lg p-4 flex items-center">
        <LocalOfferOutlinedIcon className="text-myblues-300 ml-2 mt-1" />
        <div className="flex items-center flex-wrap">
          {tags.map((item, index) => {
            return (
              <div
              style={{cursor:'pointer'}}
                onClick={() => navigate(`/news-list/tag/${item.tag}`)}
                className="border-l border-myblacks-200 text-myblacks-200  pl-2 text-xs md:text-sm mr-2 mt-2 md:mt-1 last:border-l-0"
              >
                <span>{item.tag}</span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Hashtag;
